import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { isOpenFin } from 'utils'
import { EnvironmentContext } from './EnvironmentContext'
import { createAuthorisedUserSelector } from 'selectors/connectionSelectors'
import { Application } from 'api'

type EnvironmentProviderProps = OwnProps & StateProps

interface OwnProps {
  isTearout: boolean
  children?: React.ReactNode
}

interface StateProps {
  isOpenFin: boolean
  isAdmin: boolean
}

interface DispatchProps {}

const mapStateToProps = createSelector(createAuthorisedUserSelector(), authorisedUser => ({
  isOpenFin: isOpenFin(),
  isAdmin: authorisedUser.application === Application.ADMIN_GATEWAY
}))

export const EnvironmentProviderComponent: React.FunctionComponent<EnvironmentProviderProps> = props => (
  <EnvironmentContext.Provider value={{ isOpenFin: props.isOpenFin, isAdmin: props.isAdmin, isTearout: props.isTearout }}>
    {props.children}
  </EnvironmentContext.Provider>
)

export const EnvironmentProvider = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(EnvironmentProviderComponent)
